<template>
    <Card>
        <div class="sousuo" style="width: 250px">
            <i-input placeholder='搜索客户姓名/电话' v-model="taskTitle">
                <i-button slot="append" icon="ios-search" v-on:click="searchMyTask()"></i-button>
            </i-input>
            <Button class='chongzhi search' type="primary" v-on:click="searchMyTask()">搜索</Button>
        </div>

        <div class="multiple">
            <div class="child-div">时间维度</div>
            <RadioGroup v-model="timeDimension">
                <Radio label="2">申请时间</Radio>
                <Radio label="7">进线时间</Radio>
                <Radio label="4">上门时间</Radio>
            </RadioGroup>
        </div>
        <div class="multiple" style="margin-bottom: 20px;">
            <div class="child-div">时间区间</div>
            <RadioGroup v-model="timePeriod">
                <Radio label="1"><span>今日</span></Radio>
                <Radio label="2"><span>昨日</span></Radio>
                <Radio label="3"><span>本周</span></Radio>
                <Radio label="4"><span>上周</span></Radio>
                <Radio label="5"><span>本月</span></Radio>
                <Radio label="6"><span>上月</span></Radio>
                <Radio label="7"><span>自定义</span></Radio>
                <DatePicker v-if="timePeriod == '7' " :value="timePeriodDate" @on-change="(e) => {timePeriodDate = e}"
                            type="daterange"
                            placeholder="选择日期" style="width: 200px"></DatePicker>
            </RadioGroup>
        </div>

        <Table @on-row-click='taskDetails' :columns="columns" :data="datas" size="small" ref="table">
            <template slot-scope="{ row }" slot="all_customers">
                <div style="display: flex; align-items: center;">
                    <div v-if="row.type == 1 "
                         style="width: 20px; height: 20px;display: flex;align-items: center;justify-content: center; background-color: #14BD98; color: #FFFFFF; border-radius: 50%; ">
                        个
                    </div>
                    <div v-if="row.type == 2 "
                         style="width: 20px; height: 20px; display: flex;align-items: center;justify-content: center; background-color: #0C92F4; color: #FFFFFF; border-radius: 50%;">
                        企
                    </div>
                    <div style="display: flex;flex-direction: column; align-items: center;">
                        <span>{{row.name}}</span>
                        <span>{{row.phone}}</span>
                    </div>
                </div>
            </template>
            <template slot-scope="{ row }" slot="record">
				<div v-for="(item,index) in row.entrust" :key="index">{{item.created_at}} {{item.ext_info.remark}}</div>
				<div v-if="row.entrust.length == 0">无</div>
            </template>
            <template slot-scope="{ row }" slot="action">
                <div style="display: flex; flex-direction: column; align-items: center; justify-content: space-around; height: 80px;">
                    <div style="color: #277dd3; cursor: pointer;" :data-id="row.id" @click.stop="addContractClick">添加签约合同</div>
                    <div style="color: #F61D1A;cursor: pointer;" :data-id="row.id" @click.stop="unSign">标记未签约</div>
                    <div style="color: #EDC06F;cursor: pointer;" :data-id="row.id" @click.stop="giveUp">放弃认领</div>
                </div>
            </template>
        </Table>
        <div class="pager">
            <Page :total="count" :page-size="20" :current="page" @on-change="changePage" size="small" show-elevator/>
        </div>
        <!-- 添加签约合同对话框 -->
        <Modal v-model="addContractShow" width="900">
            <AddContract ref="addContract" @reloadData="getList" :clientId="clientId"></AddContract>
            <div slot="footer">
                <Button type="primary" @click="$refs['addContract'].save()">确定</Button>
            </div>
        </Modal>
    </Card>
</template>

<script>
    import AddContract from './AddContract.vue'

	import {
		getList
	} from '@/api/client'
	import {
		unSign,giveUp
	} from '@/api/task'
	import {
		getUserList
	} from '@/api/user'
	import {mapActions, mapGetters} from "vuex";
    export default {
        name: "PendingCustomer",
        components: {
            AddContract
        },
		mounted() {
        	this.loadData();
        	this.getList();
		},
		data() {
            return {
                clientId: 0,
                addContractShow: false,
                count: 0,
                page: 1,
                taskTitle: '',
                timeDimension: '',
                timePeriod: '',
                timePeriodDate: '',
                datas: [],
				userList: [],
                columns: [
                	{
						title: '跟进人',
						key: 'follow_name',
						width: '90',
						filters: [],
						filterMultiple: false,
						filterMethod(value, row) {

						}
					},
                    {
                        title: '全部客户',
                        // key: 'all_customers',
                        slot: 'all_customers',
                        width: '130'
                    },
                    {
                        title: '性别',
                        key: 'sex_name',
                        width: '60'
                    },
                    {
                        title: '媒体代码',
                        key: 'media_name',
                        width: '100'
                    },
                    {
                        title: '需求额度',
                        key: 'loans_money',
                        width: '100',
                        filters: [],
                        filterMultiple: false,
                        filterMethod(value, row) {

                        }
                    },
                    {
                        title: '跟进记录',
                        // key: 'record',
                        slot: 'record',
                        width: '270'
                    },
                    {
                        title: '星级',
                        key: 'start_name',
                        width: '80',
                        filters: [],
                        filterMultiple: false,
                        filterMethod(value, row) {

                        }
                    },
                    {
                        title: '申请时间',
                        key: 'applied_at',
                        width: '110',
                        sortable: true
                    },
                    {
                        title: '进线时间',
                        key: 'join_at',
                        width: '110',
                        sortable: true
                    },
                    {
                        title: '上门时间',
                        key: 'view_ac_at',
                        width: '110',
                        sortable: true
                    },
                    {
                        title: '业务状态',
                        key: 'status_name',
                        width: '110',
                    },
                    {
                        title: '操作',
                        // key: 'action',
                        slot: 'action',
                        width: '110'
                    },
                ]
            }
        },
		computed: {
			...mapGetters(['token']),
		},
        methods: {
            ...mapActions([
                'handleLogOut',
                'getUserInfo',
            ]),
            addContractClick(e) {
                this.addContractShow = true;
                this.clientId = e.currentTarget.dataset.id;
            },
            searchMyTask() {
				this.page = 1;
				this.getList();
            },
            taskDetails(e) {
				let id = e.id;
				window.open('#/editClue?id=' + id);
            },
			changePage(e) {
				this.page = e;
				this.getList();
			},
			async loadData() {
            	let that = this;
				let data = {token: that.token};
				let res = await getUserList(that, data);
				if (res.code == 1) {
					that.userList = res.data.list;
				}
			},
			async getList() {
				let that = this;
                this.addContractShow = false;
				let data = {menu: 'pending_customer',timeDimension: that.timeDimension,timePeriod: that.timePeriod,timePeriodDate: that.timePeriodDate };
				data.name = this.taskTitle;
				data.token = this.token;
				data.page = this.page;
				let res = await getList(that, data);
				that.datas = res.data.list;
				that.count = res.count;
                that.getUserInfo();
			},
			// 标记未签约
			unSign(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.$Modal.confirm({
					title: '确认标记未签约吗？',
					onOk: async () => {
						let res = await unSign(that, {token: that.token, id: id});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			},
			// 放弃认领
			giveUp(e) {
				let that = this;
				let id = e.currentTarget.dataset.id;
				this.$Modal.confirm({
					title: '确认放弃认领吗？',
					onOk: async () => {
						let res = await giveUp(that, {token: that.token, id: id});
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})
			}
        }
    }
</script>

<style scoped lang="less">
    .text-center{
        height: 580px;
        overflow: scroll;
    }
    .shijian{
        position: relative;
        left: 15px;
    }
    .xiaoxi{
        position: relative;
        left: -120px;
        top: 18px;
    }
    .icon-biao{
        display: flex;
        justify-content: left;
        font-size: 15px;
        margin-bottom: 30px;
    }
    .xiangqing{
        background-color: #F9FAFA;
    }
    .biaoti{
        font-weight: bold;
    }
    .biaogetoubu{
        background-color: #F9FAFA;
        border-bottom: 1px solid #E8EAEC;
    }
    .shuju{
        margin-bottom: 10px;
        text-align: left;
        text-align-last: justify;
        display: flex;
        justify-content: left;
        div{
            margin-right:20px ;
            width: 60px;
        }
    }
    .biaogelimian{
        display: flex;
        justify-content: space-around;
    }
    .shanchu{
        margin-right: 10px;
        color: #54A1F3;
        font-size: 15px;
    }
    .biaotou{
        display: flex;
        justify-content: space-between;
    }

    .xinjianbottom {
        margin-top: 60px;
        display: flex;
        justify-content: left;
    }



    .dialoglist {
        display: flex;
        justify-content: left;
        align-items: center;
        margin-bottom: 20px;
    }

    .assign {
        position: relative;
        left: 80%;
        top: -232px;
    }

    .top-add {
        position: relative;
        width: 30px;
        left: 80%;
        bottom: 30px;
    }

    .input-text {
        margin-top: 30px;
        display: flex;
        justify-content: left;
        align-items: center;

        div {
            margin: 0 10px;
        }
    }

    .top-save {
        position: relative;
        left: 70%;
        top: -30px;
    }

    .cascader {
        width: 380px;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;

        .child-div {
            width: 60px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
        }
    }

    .chongzhi {
        position: absolute;
        top: 16px;
        left: 280px;
    }

    .sousuo {
        height: 32px;
        width: 100%;
        margin-bottom: 20px;
    }
    .ivu-table-fixed-header thead tr th{
        text-align: center;
    }
    /deep/ .ivu-table table {
        width: 100% !important;
    }
</style>
